export default __webpack_public_path__ + "static/media/thaiduong.48b0fa2e.png";